import { BaseQuantity } from "../../interface/functionalityInterface";
// Derived base quantity
// coherent SI unit is m3/s
export const Flow: BaseQuantity = {
  id: "001flow",
  name: "flow",
  type: "numeric",
  value: "",
  symbol: "Q",
  baseUnit: "m\u00b3/s",
  selectedUnit: "m\u00b3/h",
  units: [
    { name: "m\u00b3/s", fromConst: 1, toConst: 1 },
    { name: "m\u00b3/h", fromConst: 1 / 3600, toConst: 3600 },
    { name: "lps", fromConst: 1 / 1000, toConst: 1000 },
    { name: "lph", fromConst: 1 / (1000 * 3600), toConst: 1000 * 3600 },
    { name: "gpm", fromConst: 1 / 15850.3, toConst: 15850.3 },
    { name: "gph", fromConst: 1 / 951019, toConst: 951019 },
  ],
};
